import { collection, addDoc, updateDoc, getDocs, query, where, doc, getDoc } from "firebase/firestore";

import { firestoreDb } from "../firebase";
import { EQUALS, PHOTO_COLLECTIONS, SUB_COLLECTIONS } from "../constants";

const getAllUserCollections = async (userId: string) => {
  const collections = await getDocs(query(
    collection(firestoreDb, PHOTO_COLLECTIONS),
    where('ownerId', EQUALS, userId)
  ));
  return collections.docs.map((doc) => doc.data() as PhotoCollection);
}

const getCollectionById = async (collectionId: string) => {
  const collection = await getDoc(doc(firestoreDb, PHOTO_COLLECTIONS, collectionId));
  if (collection.exists()) {
    return collection.data() as PhotoCollection;
  }
  return null;
}

const addCollection = async (collectionObj: PhotoCollection) => {
  try {
    const collectionRef = await addDoc(collection(firestoreDb, PHOTO_COLLECTIONS), collectionObj);
    await updateDoc(collectionRef, { id: collectionRef.id });
    return collectionRef.id;
  } catch (e) {
    console.error("Error adding collection: ", e);
  }
}

const getSubcollections = async (collectionId: string) => {
  try {
    const subCollectionsSnapshot = await getDocs(collection(firestoreDb, PHOTO_COLLECTIONS, collectionId, SUB_COLLECTIONS));
    if (subCollectionsSnapshot.size > 0) {
      return subCollectionsSnapshot.docs.map(doc => doc.data() as SubCollection);
    };
    return null;
  } catch (error) {
    console.error('Error getting subcollections by collectionId:', error);
  }
}

const updateCollection = async (collectionObj: Partial<PhotoCollection>) => {
  try {
    const collectionRef = doc(firestoreDb, PHOTO_COLLECTIONS, collectionObj?.id);
    await updateDoc(collectionRef, collectionObj);
  } catch (e) {
    console.error("Error updating collection: ", e);
  }
}

const CollectionService = {
  getAllUserCollections,
  addCollection,
  getCollectionById,
  getSubcollections,
  updateCollection
}

export default CollectionService;
